import { BaseCard } from '@/components/uiKit/Cards';
import { SpliceNavigation } from './SpliceNavigation';
import { BletSnapshots } from './BletSnapshots';

interface BeltVisualEvidenceProps {
  selectedItem?: {
    type: string;
    name: string;
    status: string;
    nextSplice: string;
    positionLabel?: string;
    detectionImage?: string;
    afterImage?: string;
  };
  onPreviousItem: () => void;
  onNextItem: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
}

export function BeltVisualEvidence({
  selectedItem,
  onPreviousItem,
  onNextItem,
  hasPrevious,
  hasNext,
}: BeltVisualEvidenceProps) {
  return (
    <BaseCard
      variant="base"
      classNames={{
        card: 'h-full rounded-lg bg-black text-white',
        content: 'h-full flex flex-col gap-2 overflow-hidden',
      }}
    >
      <BletSnapshots
        detectionImage={selectedItem?.detectionImage}
        afterImage={selectedItem?.afterImage}
        positionLabel={selectedItem?.positionLabel}
      />
      <SpliceNavigation
        selectedItem={selectedItem}
        onPrevious={onPreviousItem}
        onNext={onNextItem}
        hasPrevious={hasPrevious}
        hasNext={hasNext}
      />
    </BaseCard>
  );
}
